<div id="layout" class="f_col">
  <app-view-title bgImage="assets-countries/header_background.png" fromRoute="welcome-hello" toRoute="choose-lang" [chooseLangBtn]="true">{{'global.hello' | translate}}</app-view-title>
  <div class="scroll_wrapper">
    <app-view-deco-image imageUrl="assets-countries/img_joyRide.svg"></app-view-deco-image>
    <app-paragraph textAlign="center" class="mb_20 fw_bold">{{'welcomeHello.title' | translate: {name: api.env.name} }}</app-paragraph>
    <div class="f_col gap_20 f_grow ">
      <app-paragraph>{{'welcomeHello.desc1' | translate: {name: api.env.name} }}</app-paragraph>
      <app-paragraph>{{'welcomeHello.desc2' | translate}}</app-paragraph>
    </div>
    <div class="f_align_end">
      <div class="fullWidth ml_10">
        <app-button (btnClicked)="nav.to( 'welcome-explain')"
                    class="fullWidth">
          {{'global.next' | translate}}
        </app-button>
      </div>
    </div>
  </div>
</div>
